import { Avatar, Badge, Dialog, DialogContent, styled } from "@mui/material";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Account from "../../views/account/Account";

const PREFIX = "AccountBadge";

const classes = {
  avatarIconSize: `${PREFIX}-avatarIconSize`,
  desktopIconSize: `${PREFIX}-desktopIconSize`,
  cursorPointer: `${PREFIX}-cursorPointer`,
  accountCircleIconDesktop: `${PREFIX}-accountCircleIconDesktop`,
};

const AccountBadgeContainer = styled("div")(({ theme }) => ({
  [`& .${classes.accountCircleIconDesktop}`]: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  [`& .${classes.cursorPointer}`]: {
    cursor: "pointer",
  },
  [`& .${classes.desktopIconSize}`]: {
    width: "30px",
    height: "30px",
  },
  [`& .${classes.avatarIconSize}`]: {
    width: "55px",
    height: "55px",
    position: "relative",
    right: "-10px",
  },
}));

const AccountBadge = ({ isOnImage }) => {
  const navigate = useNavigate();

  const loggedIn = useSelector((state) => state.user.loggedIn);
  const userAvatar = useSelector(
    (state) => loggedIn && state.user.currentUser.accountDetails.avatar
  );
  const accountEmail = useSelector(
    (state) => state.user?.currentUser?.account?.email
  );
  const accountDetailsEmail = useSelector(
    (state) => state.user?.currentUser?.accountDetails?.account?.email
  );

  const [myAvatar, setMyAvatar] = useState();
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const splittedString = userAvatar?.split("/");
    const userId = splittedString
      ? splittedString[splittedString.length - 1].split(".")[0].split("-")[1]
      : 1;
    setMyAvatar(
      userAvatar?.includes("RPM")
        ? `https://api.readyplayer.me/v1/avatars/${userId}.png`
        : userAvatar
    );
  }, [userAvatar]);

  const handleClick = () => {
    if (isOnImage) {
      setOpenDialog(true);
    } else {
      navigate("/account");
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <AccountBadgeContainer>
        {myAvatar ? (
          <Badge
            badgeContent="!"
            color="secondary"
            overlap="rectangular"
            invisible={accountEmail || accountDetailsEmail ? true : false}
          >
            <Avatar
              src={myAvatar}
              alt="my Avatar"
              onClick={handleClick}
              className={clsx(
                myAvatar.includes("RPM")
                  ? classes.avatarIconSize
                  : classes.desktopIconSize,
                classes.cursorPointer
              )}
              sx={{
                background: isOnImage && "#D3AF5F",
                boxShadow: isOnImage && "0px 0px 6px 2px rgba(0,0,0,0.9)",
              }}
            />
          </Badge>
        ) : (
          <Badge
            badgeContent="!"
            color="secondary"
            overlap="rectangular"
            invisible={accountEmail || accountDetailsEmail ? true : false}
            sx={{ padding: "0 4px" }}
          >
            <AccountCircleIcon
              className={clsx(
                classes.accountCircleIconDesktop,
                classes.cursorPointer
              )}
              onClick={handleClick}
            />
          </Badge>
        )}
      </AccountBadgeContainer>

      <Dialog open={openDialog} onClose={handleClose}>
        <DialogContent sx={{ padding: 0 }}>
          <Account closeModal={handleClose} isModal />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AccountBadge;
